import { useApproveCommissionEditRequestMutation } from "@/hooks/mutations/useApproveCommissionEditRequest";
import { useRejectCommissionEditRequestMutation } from "@/hooks/mutations/useRejectCommissionEditRequest";

export function useCommissionEditQueueActions({
  rejectNote,
  onActionSuccess,
}: {
  rejectNote: string;
  onActionSuccess: (requestId: number) => void;
}) {
  const approveMutation = useApproveCommissionEditRequestMutation();
  const rejectMutation = useRejectCommissionEditRequestMutation();

  const busyId = approveMutation.isPending
    ? approveMutation.variables
    : rejectMutation.isPending
      ? rejectMutation.variables?.requestId
      : null;

  function approveRequest(requestId: number) {
    approveMutation.mutate(requestId, {
      onSuccess: () => onActionSuccess(requestId),
    });
  }

  function rejectRequest(requestId: number) {
    rejectMutation.mutate(
      { requestId, note: rejectNote || undefined },
      {
        onSuccess: () => onActionSuccess(requestId),
      },
    );
  }

  return {
    busyId,
    approveRequest,
    rejectRequest,
  };
}
